import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import api from "./configs/api";

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

const toast_config = {
  position: "bottom-left",
};

Vue.config.productionTip = false;
Vue.prototype.$axios = api;
Vue.use(Toast, toast_config);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
